<template>
  <div style="height:100%">
    <SplitContainer2 style="height:100%" layout="horizontal" :split_setting="0.4">
      <template #table1>
        <TableMain ref="guestCustOrderTable1" name="myName" :fields="fields" :title="table_title.title1"
          :date_picker_label="date_picker_label" :query_button_label="query_lable" :show_date_picker="true"
          :show_toolbar="false" :show_filter="true" :selectable="true" @on_query="on_query" :isBusy="isBusy_table1"
          @current_changed="current_changed" :table_height_adjust="-10"
          :hb_table_class="'hb_table_guest_sods_add_class1'" :loading_width="45" tableref="66b06b635c4c4189ad1164910b6168c9">
          <template #query>
            订单编号：<el-input size="small" style="width: 120px" clearable v-model="SalesId"></el-input>
          </template>
        </TableMain>
      </template>
      <template #table2>
        <BaseContainer style="height:100%" class="one_table">
          <TableMain ref="guestCustOrderTable2" :show_query_container="false" :isBusy="isBusy_table2"
            :fields="item_fields" :show_date_picker="false" :table_height_adjust="8" :title="table_title.title2"
            :date_picker_label="date_picker_label" :query_button_label="query_lable" :show_toolbar="false"
            :pager_count="5" :hb_table_class="'hb_table_guest_sods_add_class2'" :loading_width="80" tableref="2a49e1ffae554813ab9a45641aaa21d0">
          </TableMain>
        </BaseContainer>
      </template>
    </SplitContainer2>
  </div>
</template>

<script>
// import axios from "axios"
// -- import * as _ from "lodash-es"
import * as api from "@/shared/api"
import * as localStorageMgr from "../../shared/localStorageMgr"
import QueryButton from "../components/base/QueryButton"
import TableMain from "../components/table/TableMain"
import TableDetail from "../components/table/TableDetail"
import TestQueryPanel from "../components/base/TestQueryPanel"
import BaseContainer from "../components/BaseContainer"
import EntityEditor from "../components/base/EntityEditor"
import SplitContainer2 from "../components/container/SplitContainer2"
import { Split } from "view-design"
import "view-design/dist/styles/iview.css"
import * as GuestCustController from "../../controllers/pages/GuestCustController"

export default {
  name: "GuestCustOrder",
  components: {
    QueryButton,
    TableDetail,
    TableMain,
    TestQueryPanel,
    BaseContainer,
    EntityEditor,
    Split,
    SplitContainer2,
  },
  data() {
    return {
      guest_info: null,
      date_picker_label: "common.search",
      query_lable: this.$t("common.query"),
      table_title: {
        title1: "table_sales_order",
        title2: "table_sales_order_detail",
        title3: "table_create_dispatch",
      },
      vendQuoteModal_title: "供应商报价列表",
      fields: GuestCustController.fields.default,
      item_fields: GuestCustController.fields.detail_fields,
      show_pagination: false,
      isBusy_table1: false,
      isBusy_table2: false,
      SalesId: "",
    }
  },
  activated() { },
  deactivated() { },
  computed: {
    selectSOLineItems() {
      return _.cloneDeep(this.$refs.guestCustOrderTable2.GetSelectedItems())
    },
  },
  created() {
    this.guest_info = JSON.parse(this.ls.get(localStorageMgr.data.guest_info))
  },

  mounted() { },
  methods: {
    ///查询
    async on_query(set_data, date_range) {
      this.isBusy_table1 = true
      set_data([])
      let _fromDate = "",
        _toDate = ""
      let _params = {
        pub_token: this.ls.get("pub_guest_token"),
        SalesId: this.SalesId,
      }
      if (!_.isNull(date_range) && this.SalesId == "") {
        _fromDate = this.$date.format(date_range[0], "yyyy-MM-dd")
        _toDate = this.$date.format(date_range[1], "yyyy-MM-dd")
        _toDate = this.$date.format(
          this.$date.addDays(new Date(_toDate), 1),
          "yyyy-MM-dd"
        )
        _params["fromDate"] = _fromDate
        _params["toDate"] = _toDate
      }
      let _result = await api.query_async({
        url: api.pub_url("get", this.guest_info.idx, "pub_get_cust_salesorder"),
        parameters: _params,
        method: "get",
      })


      if (
        _result &&
        _result[0] &&
        _result[0].result &&
        _result[0].result.data &&
        _result[0].result.data.Result &&
        _result[0].result.data.Result[0]
      ) {
        set_data(_result[0].result.data.Result[0])
      }

      this.isBusy_table1 = false
    },
    ///销售订单选择
    async current_changed(old, current) {
      if (_.isNull(current)) {
        this.$refs.guestCustOrderTable2.SetData([])
        return
      }
      this.isBusy_table2 = true

      let _result = await api.query_async({
        url: api.pub_url("get", this.guest_info.idx, "pub_get_cust_salesorder_line"),
        parameters: {
          pub_token: this.ls.get("pub_guest_token"),
          SalesTable_id: current.id,
        },
        method: "get",
      })


      if (
        _result &&
        _result[0] &&
        _result[0].result &&
        _result[0].result.data &&
        _result[0].result.data.Result &&
        _result[0].result.data.Result[0]
      ) {
        this.$refs.guestCustOrderTable2.SetData(
          _.orderBy(_result[0].result.data.Result[0], ["LineNum"], ["asc"])
        )
      }

      this.isBusy_table2 = false
    },
  },
}
</script>
<style>
.hb_table_guest_sods_add_class1 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 125rem;
}

.hb_table_guest_sods_add_class2 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 90rem;
}

.hideId {
  display: none;
}
</style>
<style scoped>
.one_table>>>.hb_table_query_container_one_table {
  background-color: white;
}

.hb_table_panel_container_myName>>>.b-table-sticky-header>.table.b-table>.hb_thead>.hb_thead_tr>.b-table-sticky-column.hb_thead_th_name {
  left: 21px;
}

.hb_table_panel_container_myName>>>.b-table-sticky-header>.table.b-table>.hb_tbody>.hb_tbody_tr>.b-table-sticky-column.hb_tbody_td_name {
  left: 21px;
}
</style>
